<script lang="ts" setup>
    import { reactive, inject } from 'vue';
    import { SegmentDefinition, SegmentPreviewResult } from '@cwd/views/Segments/interfaces';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { SegmentAccess } from '@cwd/Views/Segments/Segments.access';
    import SegmentGroup from '@cwd/Views/Segments/SegmentEditor/SegmentTypes/SegmentGroup.vue';
    import { getSegmentForPreview } from '@journeys/utils/previewNodeSegment';
    import { useResetOnNodeOrMenuChange } from '@journeys/utils/useResetOnNodeOrMenuChange';
    import CalculateSegmentReach from '@journeys/components/UserInterface/Menues/CalculateSegmentReach.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const segmentAccess: SegmentAccess = injectorAccess.injector.get(SegmentAccess);
    if (!segmentAccess.state.segmentTypes) segmentAccess.initWithoutSegmentId();

    const props = withDefaults(
        defineProps<{
            segmentDefinition: SegmentDefinition;
            nodeId?: number;
            btnClass?: string;
        }>(),
        {
            btnClass: '',
        }
    );

    const state = reactive({
        showSegmentDefinition: false,
        result: null as SegmentPreviewResult | null,
    });

    useResetOnNodeOrMenuChange(props, () => {
        state.showSegmentDefinition = false;
        state.result = null;
    });
</script>

<template>
    <div class="form-group m-sm-b d-flex gap-sm flex-justified flex-wrap">
        <CalculateSegmentReach :segmentDefinition="segmentDefinition" :nodeId="nodeId" :btnClass="btnClass" @result="state.result = $event" />

        <button type="button" :class="'btn btn-default text-wrap ' + btnClass" @click="state.showSegmentDefinition = !state.showSegmentDefinition">
            {{ $Resources.SegmentDefinitionLabel }}
        </button>
    </div>

    <BsAlert
        class="m-sm-b"
        v-if="state.result"
        :type="AlertTypes.Info"
        :title="$Resources.CalculateSegmentReachHead"
        :content="$Resources.CalculateSegmentReachBody.replace('{{Count}}', state.result.Count.toString())"
        :dismissible="false" />

    <div v-if="state.showSegmentDefinition">
        <SegmentGroup :segment="getSegmentForPreview(segmentDefinition)" :segmentGroup="segmentDefinition" :root="true" :viewMode="true" />
    </div>
</template>

